/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { default as SplitPane, SplitPaneProps } from 'react-split-pane';
import { getStylistV2 } from 'src/core/themes/luisStylist';

const { styleComponent } = getStylistV2('LuisSplitPane');

/**
 * Provides a styled SplitPane from react-split-pane
 */
export const LuisSplitPane = styleComponent<SplitPaneProps>(SplitPane)('LuisSplitPane', theme => ({
    $nest: {
        '& .Resizer': {
            borderWidth: '0',
            zIndex: 1,
            boxSizing: 'border-box',
            backgroundClip: 'padding-box'
        },
        '& .Resizer.vertical': {
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            cursor: 'ew-resize',
            margin: '0 -5px',
            minWidth: '1px',
            pointerEvents: 'all',
            width: '11px',
            zIndex: 2,
            $nest: {
                '&::after': {
                    background: theme.resizerBackgroundColor,
                    content: '""',
                    display: 'block',
                    height: '100%',
                    width: '1px'
                }
            }
        },
        '& .Resizer.horizontal': {
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            cursor: 'ns-resize',
            zIndex: 1,
            margin: '-5px 0',
            minHeight: '1px',
            pointerEvents: 'all',
            height: '11px',
            $nest: {
                '&::after': {
                    background: theme.resizerBackgroundColor,
                    content: '""',
                    display: 'block',
                    height: '1px',
                    width: '100%'
                }
            }
        },
        '& .Resizer.disabled': {
            cursor: 'default'
        }
    }
}));
